// extracted by mini-css-extract-plugin
module.exports =  {"grid":"cFg5G94F_vL5sQYZs7fA"};